import { http } from "../http-common";

const getSeasonRegistration = (year) => {
  return http.get(
    `/season-registration?cropYearList=${year}`
  );
};

const getSeasonRegistrationAll = (year) => {
  const cropYearList = year.map(year => `cropYearList=${year}`).join('&');
  return http.get(`/season-registration?${cropYearList}`);
};

const createSeasonRegistration = (data) => {
  return http.post("/season-registration?copyParam=false", data);
};

const updateSeasonRegistration = (data) => {
  return http.put(`/season-registration?copyParam=false`, data);
};

const handleYesRegistration = (res, data) => {
  return http.post(`/season-registration?copyParam=${res}`, data);
};

const getCropYears = (data) => {
    return http.get(`/cropYears`, data);
  };

const addCropStageCalendar = (data) => {
  return http.post('/crop-stage-calendar',data);
};

const SeasonRegistrationService = {
  getSeasonRegistration,
  createSeasonRegistration,
  updateSeasonRegistration,
  handleYesRegistration,
  getCropYears,
  addCropStageCalendar,
  getSeasonRegistrationAll
};

export default SeasonRegistrationService;
